import axios from 'axios';

export const listQuickCashflowModels = async (customerId) => {
  const response = await axios.get('admin/quick-cashflow/models', {
    params: { customerId },
  });
  return response.data;
};

export const getQuickCashflowModel = async (id) => {
  const response = await axios.get(`admin/quick-cashflow/models/${id}`);
  return response.data;
};

export const saveQuickCashflowModel = async ({
  customerId,
  name,
  model,
  result,
}) => {
  const response = await axios.post('admin/quick-cashflow/models', {
    customerId,
    name,
    model,
    result,
  });
  return response.data;
};

export const deleteQuickCashflowModelOpenAIFiles = async (id) => {
  const response = await axios.post(
    `admin/quick-cashflow/models/${id}/delete-openai-files`
  );
  return response.data;
};

export const getQuickCashflowExtractStatus = async (id, jobId) => {
  const response = await axios.get(
    `admin/quick-cashflow/models/${id}/extract-status`,
    { params: { jobId } }
  );
  return response.data;
};

export const cancelQuickCashflowExtractJob = async (jobId) => {
  const response = await axios.post(
    `admin/quick-cashflow/extract-jobs/${jobId}/cancel`
  );
  return response.data;
};

export const deleteQuickCashflowModel = async (id) => {
  await axios.delete(`admin/quick-cashflow/models/${id}`);
};

export const exportQuickCashflowModelToDrive = async ({
  customerId,
  modelName,
  excelBlob,
  excelFilename,
  pptxBlob = null,
  pptxFilename = null,
  odtBlob = null,
  odtFilename = null,
  dealExcelBlob = null,
  dealExcelFilename = null,
}) => {
  const form = new FormData();
  form.append('customerId', customerId);
  form.append('modelName', modelName);
  form.append('excel', excelBlob, excelFilename);
  if (pptxBlob && pptxFilename) {
    form.append('pptx', pptxBlob, pptxFilename);
  }
  if (odtBlob && odtFilename) {
    form.append('odt', odtBlob, odtFilename);
  }
  if (dealExcelBlob && dealExcelFilename) {
    form.append('dealExcel', dealExcelBlob, dealExcelFilename);
  }
  const response = await axios.post(
    'admin/quick-cashflow/models/export-to-drive',
    form
  );
  return response.data;
};
